import React, { useEffect, useState } from 'react';
import CollegeProfile from '../College/CollegeProfile'
import CollegeHomeContainer from '../Container/CollegeHomeContainer'
import ReactTooltip from "react-tooltip";
import { API } from '../../API';

const CollegeSharedProfile = (props) => {
  const [state, setState] = useState({
    campuses: props.location.state.campuses,
    institution: props.location.state.inst,
    personnels: props.location.state.personnel,
  });
  const [qualificationList, setQualificationList] = useState([])
  const [selectedList, setSelectedList] = useState([])
  const [selectedByQualification, setSelectedByQualification] = useState({})
  const [selectedRoomsProgramsQual, setSelectedRoomsProgramsQual] = useState([])

  const tabs = [
    {
      text: 'Institute Profile',
      active: true,
    },
  ];

  useEffect(() => {
    API.getQualificationList().then(result => {
      const qualifications = result?.data?.data
      setQualificationList(qualifications)

      // check selectedList
      const { selected_can_delivers, selected_rooms_programs = [] } = state.institution
      const selectedItem = {}
      const selectedByQualification = {}
      const ececSelectedRoomsProgramsQual = []

      qualifications.forEach(item => {
          const quaList = item.qualifications
          if(item.type === 'vet') {
              quaList.forEach(qua => {
                  const { units } = qua
                  units.forEach(unit => {
                      if(selected_can_delivers.includes(unit._id)) {
                          const key = `${qua.title}_keyID:${qua._id}`
                          const unitItem = `${unit.title}_id:${unit._id}`
                          if(selectedItem[key]?.length) {
                              if(!selectedItem[key]?.includes(unitItem)) {
                                  selectedItem[key].push(unitItem)
                              }
                          }
                          else {
                              selectedItem[key] = [unitItem]
                          }

                          if(selectedByQualification[qua._id]?.length) {
                              selectedByQualification[qua._id].push(unit._id)
                          }
                          else {
                              selectedByQualification[qua._id] = [unit._id]
                          }
                      }
                  })
              })
          }
          else {
              const key = `${item.qualification_name}_keyID:${item._id}`
              quaList.forEach(qua => {
                  const quaItem = `${qua.title}_id:${qua._id}`
                  if(selected_can_delivers.includes(qua._id)) {
                      if(selectedItem[key]?.length) {
                          if(!selectedItem[key]?.includes(quaItem)) {
                              selectedItem[key].push(quaItem)
                          }
                      }
                      else {
                          selectedItem[key] = [quaItem]
                      }
                  }
              })
          }

          if (item.type === 'ecec') {
            quaList.forEach((qua => {
                if (selected_rooms_programs.includes(qua._id)) {
                    ececSelectedRoomsProgramsQual.push(qua)
                }
            }))
        }
      })
      setSelectedList(selectedItem)
      setSelectedByQualification(selectedByQualification)
      setSelectedRoomsProgramsQual(ececSelectedRoomsProgramsQual)
    })
  }, [])

  const wwccRequiredColleges = ["ILSC Education Group Australia", "Focus Language School", "Acknowledge Education"];

  return (
    <CollegeHomeContainer
      isShared
      institution={state.institution}
      tabs={tabs}
      isViewAsTeacher={false}
      isShowUploadAvatar={false}
      tabProfileActive={true}
      offset={true}
      removeTopMargin={true}
    >
      <div className={wwccRequiredColleges.includes(state.institution.institution_name) ? "" : "d-none"}>
        <div
          className="mdi mdi-face"
          style={{ fontSize: "60px", color: "mediumblue", position: "absolute", left: "3%", top: "-5px" }}
          data-tip="Teacher requirement, on-campus delivery"
          data-for="wwcc-hover"
        >
          {" "}
        </div>
        <ReactTooltip
          backgroundColor="rgb(47, 224, 222)"
          id="wwcc-hover"
          effect="solid"
        />
      </div>
      {qualificationList?.length && <CollegeProfile
        campuses={state.campuses}
        personnels={state.personnels}
        institution={state.institution}
        selectedItem={selectedList}
        selectedCanDelivers={state.institution.selected_can_delivers}
        qualifications={qualificationList}
        selectedByQualification={selectedByQualification}
        selectedRoomsProgramsQual={selectedRoomsProgramsQual}
      />}
    </CollegeHomeContainer>
  );
};

export default CollegeSharedProfile;
